import { Language } from './types';

// apps/users/api/serializers.py BE need specific error codes for 3 cases
// apps/utils/exceptions/errors.py BE need to define missing codes

const BASE_LANGUAGE_LABELS = {
  Unabletologinwithprovidedcredentials:
    'Unable to Login with provided credentials.',
  passwordoremailareincorrect: 'Password or email are incorrect.',
  500: 'Service temporarily unavailable, try again later.',
  503: 'Service temporarily unavailable, try again later.',
  1000: 'Service temporarily unavailable, try again later.',
  2001: 'Incorrect username or password.',
  2002: "You don't have access to this resource",
  2004: 'Must include "username" and "password".',
  2010: 'This email is already used for an EFEX account. Try with another one.',
  3003: 'The digits of the account and/or routing number are incorrect',
  5001: 'Can’t create payable. Please contact our team for further information',
  6000: 'Rate for exchange not found',
  6001: 'Conversion unsuccessful',
  4010: 'This clabe is already used for an EFEX account. Try with another one.',
  9000: 'The contact already exists, please try a different email address.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const ERROR_CODES_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    Unabletologinwithprovidedcredentials:
      'No se puede iniciar sesión con las credenciales proporcionadas',
    passwordoremailareincorrect:
      'La contraseña o el correo electrónico son incorrectos.',
    500: 'Servicio temporalmente no disponible, inténtalo de nuevo más tarde.',
    503: 'Servicio temporalmente no disponible, inténtalo de nuevo más tarde.',
    1000: 'Servicio temporalmente no disponible, inténtalo de nuevo más tarde.',
    2001: 'Usuario o contraseña incorrecta.',
    2002: 'No tienes acceso a este recurso.',
    2004: 'Debe incluir "nombre de usuario" y "contraseña".',
    2010: 'Este correo electrónico ya se utiliza para una cuenta EFEX. Prueba con otro.',
    3003: 'Los datos del número de cuenta y/o routing number son incorrectos',
    5001: 'No se puede crear el pago. Por favor contáctanos para más información',
    6000: 'No se encontró la tasa de cambio',
    6001: 'Conversión no exitosa',
    4010: 'La clabe interbancaria es usada por otra cuenta EFEX. Intenta usando una diferente.',
    9000: 'El contacto ya existe, por favor intenta con un correo electrónico diferente.',
  },
};

export default ERROR_CODES_LANGUAGE_LABELS;
